import { useState } from "react";
import PiggyContext from "./PiggyContext";

function PiggyState(props) {
  const [rows, setRows] = useState([]);
  return (
    <PiggyContext.Provider value={{ rows, setRows }}>
      {props.children}
    </PiggyContext.Provider>
  );
}

export default PiggyState;
